import { ReviewForgeElementType } from "@redotech/redo-content-builder-common/forge/review-forge-types";
import {
  numberToReviewRating,
  ReviewFieldSchemaType,
} from "@redotech/redo-review-db-schema/review";
import { ReviewField } from "@redotech/redo-review-db-schema/review-db-parser";
import { PossibleSubmittableData } from "@redotech/redo-web/reviews-form/review-form-types";
import { assertNever } from "@redotech/util/type";

export function formDataToReviewField(
  formData: [string, PossibleSubmittableData],
): ReviewField {
  const [key, value] = formData;

  switch (value.type) {
    case ReviewForgeElementType.SHORT_ANSWER:
      return {
        fieldType: ReviewFieldSchemaType.REVIEW_SHORT_ANSWER,
        semanticTagId: key,
        text: value.answer,
      };
    case ReviewForgeElementType.STARS:
      return {
        semanticTagId: key,
        fieldType: ReviewFieldSchemaType.REVIEW_RATING,
        rating: numberToReviewRating(value.rating),
      };
    case ReviewForgeElementType.MEDIA_UPLOAD:
      return {
        semanticTagId: key,
        fieldType: ReviewFieldSchemaType.REVIEW_MEDIA_UPLOAD,
        text: value.url,
      };
    case ReviewForgeElementType.SINGLE_SELECT:
      return {
        semanticTagId: key,
        fieldType: ReviewFieldSchemaType.REVIEW_SINGLE_CHOICE,
        text: value.selectedOption,
      };
    case ReviewForgeElementType.PARAGRAPH:
      return {
        semanticTagId: key,
        fieldType: ReviewFieldSchemaType.REVIEW_PARAGRAPH,
        text: value.value,
      };
    default:
      assertNever(value);
  }
}
